import { ExtendedDailyParticipant } from "@daily-co/daily-react";
import { getInitialUser, User } from "../models/User";
import { DailyEventObjectAppMessage } from "@daily-co/daily-js";
import { AppMessage, SetUserPositionAndRotationWorldMessage, SetUserRotationWorldMessage, SetUserTableValueWorldMessage, WorldMessage } from "../models/Types";

export function getUserForParticipant(participant: ExtendedDailyParticipant | null) {
  if (!participant) return getInitialUser();
  const participantTracks = getParticipantTracks(participant);
  const user = new User(participant.user_id,
                        participant.user_name + participant.user_id.substr(0, 4),
                        participant.local,
                        participant.joined_at,
                        participant.session_id,
                        participantTracks.audio,
                        participantTracks.video);
  return user;
}

export function getParticipantTracks(participant: ExtendedDailyParticipant) {
  const tracks = participant?.tracks;
  if (!tracks) return { video: null, audio: null };

  const vt = <{ [key: string]: any }>tracks.video;
  const at = <{ [key: string]: any }>tracks.audio;

  const videoTrack =
    vt?.state === 'playable' ? vt["persistentTrack"] : null;
  const audioTrack =
    at?.state === 'playable' ? at["persistentTrack"] : null;
  return {
    video: videoTrack,
    audio: audioTrack,
  };
}

/*
  action: Extract<DailyEvent, 'app-message'>;
  data: Data;
  fromId: string;
*/

export function createAppMessage(event: DailyEventObjectAppMessage) {
  if (event.data.messageType === 'world') {
    if (event.data.worldMessageType === 'set-user-position-and-rotation') {
      const message: SetUserPositionAndRotationWorldMessage = {
        messageType: 'world',
        worldMessageType: 'set-user-position-and-rotation',
        headRotation: event.data.headRotation,
        movement: event.data.movement,
        position: event.data.position
      }
      const result: AppMessage = {
        userId: event.fromId,
        message
      };
      return result;
    }
    else if (event.data.worldMessageType === 'set-user-rotation') {
      const message: SetUserRotationWorldMessage = {
        messageType: 'world',
        worldMessageType: 'set-user-rotation',
        headRotation: event.data.headRotation,
      }
      const result: AppMessage = {
        userId: event.fromId,
        message
      };
      return result;
    }
    else if (event.data.worldMessageType === 'set-user-table-value') {
      const message: SetUserTableValueWorldMessage = {
        messageType: 'world',
        worldMessageType: 'set-user-table-value',
        tablePosition: event.data.tablePosition,
        seatedAt: event.data.seatedAt,
      }
      const result: AppMessage = {
        userId: event.fromId,
        message
      };
      return result;
    }
    else if (event.data.worldMessageType === 'get-initial-state') {
      const message: WorldMessage = {
        messageType: 'world',
        worldMessageType: 'get-initial-state',
      }
      const result: AppMessage = {
        userId: event.fromId,
        message
      };
      return result;
    }
    else {
      const result: AppMessage = {
        userId: event.fromId,
        message: {
          messageType: 'world',
          worldMessageType: 'unknown'
        }
      };
      return result;
    }  
  }
  else {
    const result: AppMessage = {
      userId: event.fromId,
      message: {
        messageType: 'world',
        worldMessageType: 'unknown'
      }
    };
    return result;
  }
} 